import React, { useState } from 'react';
import { useCollectionData } from 'react-firebase-hooks/firestore';
import { firestore } from '../firebase';
import Button from 'react-bootstrap/Button';
import ActivityRow from '../components/activityRow';
import { Modal } from 'react-bootstrap';
import LeaderIcons from '../components/LeaderIcons';
import useGaTracker from '../useGaTracker';
import { EventWithId, User } from '../types/Firestore';
import { useFirebaseContext } from '../state/firebase';

function createEventRef(showOnlyMine: boolean, user?: User) {
  const today = new Date().toISOString().split('T')[0];

  // use below if you want yesterday to be shown in activities.
  let yesterday: Date | string = ((d) => new Date(d.setDate(d.getDate() - 1)))(new Date());
  yesterday = yesterday.toISOString().split('T')[0];

  if (showOnlyMine && user) {
    if (user.rank === 'ledare') {
      return (
        firestore
          .collection('events')
          .where('leaders', 'array-contains', user.uid)
          // .where('date', '<=', today)
          .orderBy('date', 'asc')
      );
    }

    return firestore.collection('events').where('attendees', 'array-contains', user.uid).orderBy('date', 'asc').orderBy('time_start', 'asc');
  }

  return firestore.collection('events').where('date', '>=', yesterday).orderBy('date', 'asc').orderBy('time_start', 'asc');
}

export default function Activities() {
  useGaTracker();
  const { user } = useFirebaseContext();
  const showOnlyMine = window.location.search.includes('mina');

  const [show, setShow] = useState<string | boolean>(false);

  const handleClose = () => {
    setShow(false);
  };

  const eventsRef = createEventRef(showOnlyMine, user);
  const [events, loading] = useCollectionData<EventWithId>(eventsRef, {
    idField: 'id',
  });

  if (loading || typeof events === 'undefined') {
    return null;
  }

  const leadersEvent = events.find((event) => event.id === show);

  const textToShow = showOnlyMine && user?.rank === 'user' ? 'Mina aktiviteter' : showOnlyMine && user?.rank === 'ledare' ? 'Mina tider' : 'Aktiviteter';

  return (
    <div className='activities'>
      <h4 className='activities-title'>{textToShow}</h4>
      {events.map((event, i) => (
        <ActivityRow event={event} key={i} />
      ))}
      <Modal show={!!show} onHide={handleClose} backdrop='static' keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>Ledare</Modal.Title>
        </Modal.Header>
        <Modal.Body>{leadersEvent && <LeaderIcons leaderIds={leadersEvent.leaders} />}</Modal.Body>
        <Modal.Footer>
          <Button className='btn-custom btn btn-close' onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
